import React from 'react';
import { useSnapshot } from 'valtio';
import { Box, Paper, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import WarningOutlinedIcon from '@material-ui/icons/WarningOutlined';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { useTranslation } from 'react-i18next';
import getStateManager from '../../StateManager';
import { alarmDisplayName } from '../../Utils/alarm_utils';
import { InfoButton } from '../../FormWidgets/Description';

export default function DashboardAlarms({ controller }) {
  const state = getStateManager();
  const manager = useSnapshot(state);
  const current = useSnapshot(controller);
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const controllerId = current.id;
  const active = manager.alarms.activeAlarms.filter((alarm) =>
    (alarm.controller?.id ?? alarm.controller_id) === controllerId);
  // /api/controller supplies the initial alarm list before controllers_loaded.
  // Resync clears awaiting_values only after fresh controller readback.
  const available = manager.controllers_loaded && current.id !== 'local' &&
    current.connection?.status === 'good' && !current.connection?.awaiting_values;
  const Icon = active.length ? WarningOutlinedIcon : available ? CheckCircleOutlineIcon : HelpOutlineIcon;
  const color = active.length ? theme.palette.error.main : available ? theme.palette.primary.main : theme.palette.text.secondary;
  return <Paper style={{ padding: 16, marginBottom: 16 }}>
    <Box display="flex" alignItems="center" style={{ gap: 12 }} role="status">
      <Icon style={{ color }} />
      <Typography variant="h6" component="h2" style={{ color }}>
        {t(active.length ? 'database_active_alarms' : available ? 'database_all_good' : 'database_alarm_unavailable', { count: active.length })}
      </Typography>
      <InfoButton brief={t('alarms')} content={t('database_alarm_status_help')} />
    </Box>
    {active.map((alarm) => <Typography key={alarm.id} variant="body2">
      {current.zones?.[alarm.zone]?.name ? current.zones[alarm.zone].name + ' · ' : ''}
      {alarmDisplayName(alarm, manager.alarm_catalog_state?.entries, i18n?.language, t)}
    </Typography>)}
    {active.length > 0 && !available && <Typography variant="caption" color="textSecondary">{t('database_alarm_unavailable')}</Typography>}
  </Paper>;
}
